/* Berry theme · information, help and legal pages (D4b). Ported from the approved prototypes (pages.js, sizes.js):
     · tabs (size guide, care guide): roving tabindex, arrow keys, Home / End, the address keeps the tab (#rings);
       phones choose the tab from a select
     · accordions (legal pages, FAQ): <details data-anim> ease open and closed in 0.3s; #anchor opens one
     · size guide: the cm / inches switch converts every "92 cm", "1.73 cm", "57 mm", "14–15.5 cm" cell (remembered)
     · FAQ: #topic shows a category, #topic-2 one answer; the search looks through every question and answer
     · underlined forms (contact, Coming soon): required fields, email, phone and pattern checks before sending
   Every text comes from the section settings (data attributes); nothing here is hard-coded copy. */
(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const BV = (window.BV = window.BV || {});
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const esc = (t) => String(t).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const announce = (t) => { const l = document.getElementById('bv-live'); if (l) { l.textContent = ''; setTimeout(() => { l.textContent = t; }, 50); } };

  // ---------------------------------------------------------------- Tabs
  const wireTabs = (root) => {
    const list = $('[role="tablist"]', root);
    if (!list) return;
    const tabs = $$('[role="tab"]', list);
    const sel = $('[data-tab-select]', root);
    const select = (tab, focus = false, push = true) => {
      tabs.forEach((t) => {
        const on = t === tab;
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
        const p = document.getElementById(t.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
      if (sel) sel.value = tab.dataset.key;
      if (focus) tab.focus();
      if (push) history.replaceState(null, '', `#${tab.dataset.key}`);
      if (list.scrollWidth > list.clientWidth) tab.scrollIntoView({ block: 'nearest', inline: 'center' });
    };
    list.addEventListener('click', (e) => { const t = e.target.closest('[role="tab"]'); if (t) select(t); });
    list.addEventListener('keydown', (e) => {
      const i = tabs.indexOf(document.activeElement);
      if (i < 0) return;
      const k = { ArrowRight: i + 1, ArrowLeft: i - 1, Home: 0, End: tabs.length - 1 }[e.key];
      if (k === undefined) return;
      e.preventDefault();
      select(tabs[(k + tabs.length) % tabs.length], true);
    });
    if (sel) sel.addEventListener('change', () => { const t = tabs.find((x) => x.dataset.key === sel.value); if (t) select(t); });
    const fromHash = () => tabs.find((t) => `#${t.dataset.key}` === location.hash);
    const start = fromHash();
    if (start) select(start, false, false);
    else if (sel && tabs[0]) sel.value = tabs[0].dataset.key;
    addEventListener('hashchange', () => { const t = fromHash(); if (t) select(t, false, false); });
  };
  $$('[data-tabs]').forEach(wireTabs);

  // ---------------------------------------------------------------- Accordions
  const wireAccordions = (scope) => {
    $$('details[data-anim]', scope).forEach((d) => {
      if (d.dataset.wired) return;
      d.dataset.wired = '1';
      const s = $('summary', d);
      const body = s && s.nextElementSibling;
      s.addEventListener('click', (e) => {
        if (reduce || !body) return;
        e.preventDefault();
        const end = () => { body.style.cssText = ''; };
        body.style.overflow = 'hidden';
        if (d.open) {
          body.style.height = `${body.scrollHeight}px`;
          requestAnimationFrame(() => { body.style.transition = 'height 300ms ease-in'; body.style.height = '0px'; });
          body.addEventListener('transitionend', () => { d.open = false; end(); }, { once: true });
        } else {
          d.open = true;
          const h = body.scrollHeight;
          body.style.height = '0px';
          requestAnimationFrame(() => { body.style.transition = 'height 300ms ease-in'; body.style.height = `${h}px`; });
          body.addEventListener('transitionend', end, { once: true });
        }
      });
    });
  };
  const openFromHash = (scope) => {
    if (!location.hash) return;
    let target = null;
    try { target = scope.querySelector(`details${CSS.escape(location.hash)}`); } catch (e) { target = null; }
    if (target) { target.open = true; setTimeout(() => target.scrollIntoView({ block: 'start' }), 50); }
  };
  $$('[data-legal]').forEach((l) => { wireAccordions(l); openFromHash(l); });

  // ---------------------------------------------------------------- Size guide: cm / inches
  const UNIT_KEY = 'bv-units';
  const store = { get: () => { try { return localStorage.getItem(UNIT_KEY); } catch (e) { return null; } }, set: (v) => { try { localStorage.setItem(UNIT_KEY, v); } catch (e) { /* blocked */ } } };
  const inch = (cm) => { const v = Math.round((cm / 2.54) * 2) / 2; return Number.isInteger(v) ? String(v) : v.toFixed(1); };
  const MEASURE = /^(\d+(?:\.\d+)?)(?:\s*[–-]\s*(\d+(?:\.\d+)?))?\s*(cm|mm)$/;
  const toInches = (text) => {
    const m = text.trim().match(MEASURE);
    if (!m) return null;
    const a = parseFloat(m[1]); const b = m[2] ? parseFloat(m[2]) : null; const unit = m[3];
    if (unit === 'mm') return `${[a, b].filter((x) => x !== null).map((x) => (x / 25.4).toFixed(2)).join('–')} in`;
    // Small lengths (rings, under 10 cm) keep two decimals in inches; body measures round to the half inch
    const one = (x) => (x < 10 ? (x / 2.54).toFixed(2) : inch(x));
    return `${[a, b].filter((x) => x !== null).map(one).join('–')} in`;
  };
  const units = $('[data-units]');
  if (units) {
    const cells = $$('.bv-table__t td, .bv-table__t tbody th', units).filter((c) => MEASURE.test(c.textContent.trim()));
    cells.forEach((c) => { c.dataset.cm = c.textContent.trim(); c.dataset.in = toInches(c.dataset.cm); });
    const apply = (u) => {
      cells.forEach((c) => { c.textContent = u === 'in' ? c.dataset.in : c.dataset.cm; });
      $$('[data-unit]', units).forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.unit === u)));
    };
    if (store.get() === 'in') apply('in');
    units.addEventListener('click', (e) => { const b = e.target.closest('[data-unit]'); if (!b) return; store.set(b.dataset.unit); apply(b.dataset.unit); });
  }

  // ---------------------------------------------------------------- FAQ
  const faq = $('[data-faq]');
  if (faq) {
    const landing = $('[data-faq-landing]', faq);
    const topics = $$('[data-faq-topic]', faq);
    const results = $('[data-faq-results]', faq);
    const input = $('#faq-q', faq);
    const plain = (el) => el.textContent.replace(/\s+/g, ' ').trim();
    topics.forEach((t) => wireAccordions(t));
    const show = (view) => {
      landing.hidden = view !== landing;
      topics.forEach((t) => { t.hidden = t !== view; });
      results.hidden = view !== results;
    };
    const markCats = (key) => $$('[data-faq-cat]', faq).forEach((a) => { if (a.dataset.faqCat === key) a.setAttribute('aria-current', 'page'); else a.removeAttribute('aria-current'); });
    const search = (q) => {
      const words = q.toLowerCase().split(/\s+/).filter((w) => w.length > 2);
      const hits = [];
      topics.forEach((t) => $$('details', t).forEach((d) => {
        const qq = plain($('.bv-faq__q', d)).toLowerCase(); const a = plain($('.bv-faq__a', d)).toLowerCase();
        const score = words.reduce((n, w) => n + (qq.includes(w) ? 3 : 0) + (a.includes(w) ? 1 : 0), 0);
        if (score > 0) hits.push({ d, score });
      }));
      hits.sort((x, y) => y.score - x.score);
      const list = $('[data-faq-results-list]', results);
      list.innerHTML = '';
      hits.forEach(({ d }) => { const c = d.cloneNode(true); c.removeAttribute('id'); c.open = false; delete c.dataset.wired; list.appendChild(c); });
      wireAccordions(list);
      $('[data-faq-results-title]', results).textContent = (faq.dataset.resultsTitle || '').replace('[query]', q);
      const none = $('[data-faq-none]', results);
      none.hidden = hits.length > 0;
      none.textContent = (faq.dataset.none || '').replace('[query]', q);
      markCats('');
      show(results);
      announce((faq.dataset.found || '').replace('[count]', hits.length));
    };
    const route = () => {
      const h = decodeURIComponent(location.hash.slice(1));
      const q = new URLSearchParams(location.search).get('q');
      const t = h && topics.find((x) => x.dataset.faqTopic === h || h.startsWith(`${x.dataset.faqTopic}-`));
      if (t) {
        show(t); markCats(t.dataset.faqTopic);
        const one = h !== t.dataset.faqTopic && document.getElementById(h);
        if (one && one.tagName === 'DETAILS') { one.open = true; setTimeout(() => one.scrollIntoView({ block: 'start' }), 50); }
        else window.scrollTo({ top: 0 });
      } else if (q) { input.value = q; search(q); } else { show(landing); }
    };
    $('[data-faq-search]', faq).addEventListener('submit', (e) => {
      e.preventDefault();
      const q = input.value.trim();
      if (!q) { input.focus(); return; }
      history.pushState(null, '', `${location.pathname}?q=${encodeURIComponent(q)}`);
      search(q);
    });
    addEventListener('hashchange', route);
    addEventListener('popstate', route);
    route();
  }

  // ---------------------------------------------------------------- Contact: the topic select opens its page
  const pick = $('[data-ct-pick]');
  if (pick) pick.addEventListener('change', () => { const v = pick.value; if (!v) return; if (v.charAt(0) === '#') { const t = document.getElementById(v.slice(1)); if (t) t.scrollIntoView({ block: 'start', behavior: reduce ? 'auto' : 'smooth' }); } else location.href = v; });

  // ---------------------------------------------------------------- Underlined forms: checks before sending
  const T = (window.BV_THEME && window.BV_THEME.t) || {};
  const MSG = { email: T.form_email || 'Please enter a complete email address, for example name@example.com.', tel: T.form_tel || 'Please enter a phone number, for example 010 0000 0000.', req: T.form_required || 'This field is required.', pattern: T.form_pattern || 'Please check this field.' };
  const checkForm = (form) => {
    let first = null;
    $$('.bv-lfield', form).forEach((f) => {
      const el = $('.bv-lfield__input', f);
      if (!el) return;
      const v = el.value.trim();
      let err = '';
      if (el.required && !v) err = MSG.req;
      else if (v && el.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) err = MSG.email;
      else if (v && el.type === 'tel' && !/^\+?[\d\s-]{8,16}$/.test(v)) err = MSG.tel;
      else if (v && el.dataset.pattern && !new RegExp(el.dataset.pattern).test(v)) err = MSG.pattern;
      f.classList.toggle('is-error', !!err);
      el.setAttribute('aria-invalid', String(!!err));
      const m = $('.bv-lfield__msg', f);
      if (m) m.textContent = err;
      if (err && !first) first = el;
    });
    $$('input[type=checkbox][required]', form).forEach((c) => { const m = c.closest('.bv-check'); if (m) m.classList.toggle('is-error', !c.checked); if (!c.checked && !first) first = c; });
    if (first) first.focus();
    return !first;
  };
  $$('#contact-form, #soon-form').forEach((form) => {
    form.addEventListener('submit', (e) => { if (!checkForm(form)) e.preventDefault(); });
  });
  const done = $('[data-contact-done]');
  if (done) { done.scrollIntoView({ block: 'center' }); done.focus({ preventScroll: true }); }

  BV.wireAccordions = wireAccordions;
  BV.esc = BV.esc || esc;
})();
